import React, {useCallback, useEffect, useState} from 'react';

function useFittedElementsInContainer(
  containerRef: React.RefObject<HTMLElement>,
  elementSize: number,
  gapBetweenElements = 0,
  defaultElementsCount = 1,
  minElementsCount = 1
) {
  const [fittedElements, setFittedElements] = useState(defaultElementsCount);

  const calculateFittedElements = useCallback(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const elementSizeWithGap = elementSize + gapBetweenElements;
      const calculatedAmount = containerWidth / elementSizeWithGap;

      setFittedElements(
        Math.floor(
          Math.max(
            Math.min(calculatedAmount, defaultElementsCount),
            minElementsCount
          )
        )
      );
    }
  }, [elementSize, gapBetweenElements, defaultElementsCount, minElementsCount]);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) {
      return undefined;
    }

    const observer = new ResizeObserver(() => {
      calculateFittedElements();
    });

    observer.observe(element);
    calculateFittedElements();

    return () => {
      observer.disconnect();
    };
  }, [calculateFittedElements]);

  return fittedElements;
}

export default useFittedElementsInContainer;
